<template>
<div style="position:relative"  @blur="stepBlur(step)" :id="'step' + step._id" class="xxray flow-step"
    :class="{'selected': step._selected, 'active': isActive(step), 'complete': step.complete, 'expanded': step.expanded, 'no-margin': (level == 500)}"
    
>
    <!-- Header -->
    <div class="header-outer" :style="flowStepStyle" >
        <div class="flow-step-header" tabindex="0" @focus="stepFocus(step)"   :class="{expanded: step.expanded, selected: step._selected, 'flow-step-line': hasLines(step), condensed: step.type=='checkbox'}" >
            <div class="flow-step-indicator" :class="{active: isActive(step), selected:step._selected}">

            </div>
            <div class="flow-step-icon" @click.stop="stepIconClicked(step)" @xxxxxmousedown.prevent >
                <div class="flow-step-icon-shadow">
                    <v-progress-circular :indeterminate="step._loading" class="blue-background" :rotate="270" :size="36" :width="2" :value="step.percent" color="blue lighten-2">
                        <v-icon style="margin:2px;" large :color="getIconColour(step)">{{getIconName(step)}}</v-icon>
                    </v-progress-circular>
                </div>
            </div>
            <div class="flow-step-content" @click="clicked($event, step)">
                <div class="flow-step-input">
                    <input v-if="isActive(step) && $page.designing" class="new-item-text" ref="newStep" type="text" v-model="step.title" placeholder="New Item..." />
                    <template v-else>
                        <StepSelector :step="step" @track-changes="trackChanges" />
                    </template>
                </div>
                <div v-if="showScheduler()" class="flow-step-schedule">
                    <DueIndicator :task="step" style="margin-left:auto;" />
                </div>
            </div>
            <div class="flow-step-handle">
                <div v-if="step.children" class="round pa-1 hoverable clickable" icon @click.stop="iconClicked(step, $event)">
                    <div class="drag-handle">
                        <v-icon class="expander-icon" :class="{expanded:step.expanded}" color="grey">arrow_drop_down</v-icon>
                    </div>
                </div>
                <div v-else class="round pa-1 hoverable clickable" icon @click.stop="iconClicked(step, $event)">
                    <div class="drag-handle">
                        <v-icon class="expander-icon" :class="{expanded:step.expanded}" color="grey lighten-2">more_vert</v-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Expansion Area -->

    <div v-if="step.expanded" style="position:relative" class="flow-step-expander" :class="{expanded: step.expanded, 'elevation-3': (level == 500), 'ma-1': false}">
        <div class="expanded-content" >
            <template v-for="child in step.children">
                <Flow :id="child" :level="level + 1" :key="'child' + child" />
            </template>
        </div>   
    </div>

</div>
</template>

<script>
import ObjectArrayHelpers from '../helpers/ObjectArrayHelpers'

import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import { addDays } from 'date-fns'
// import Flow from './Flow'

import DueIndicator from './ui/DueIndicator'
import NumberHelpers from '../helpers/NumberHelpers'
import StepSelector from './StepSelector'
import Firestore from '../data/Firestore'
import Utilities from '@/helpers/Utilities'
import ContactHelpers from '../helpers/ContactHelpers'


export default {
    data() {
        return {
            designing: false,
            readOnly: false,
        }
    },

    inject: ['$page'],

    components: {
        DueIndicator, StepSelector,
    },
    
    props: {
        step: Object,
        level: Number,
    },

    computed: {
        flowStepStyle() {
            let style = {}
            if(this.step.important) {
                style['background-size'] = 'contain' // '180px'
                style['background-position'] = '45px 0px'
                style['background-image'] = `url(/static/images/hilight${this.step.important}.png)`
            }
            return style
        }
    },

    methods: {
        stepIconClicked(step) {
            this.quickLoader()
            this.toggle(step, 'complete')
            this.$delete(step, 'percent')
        },

        quickLoader(milliseconds = 900) {
            this.toggle(this.step, '_loading')
            setTimeout( () => {
                this.$delete(this.step, '_loading')
            }, milliseconds)            
        },

        iconClicked(step) {
            if(step.expanded) {
                this.$children.forEach(childWorkflow => {
                    console.log(childWorkflow)
                })
            } else
                this.quickLoader(1200)
            this.toggle(step, 'expanded')
        },

        toggle(step, field) {
            console.log('setting step to ' + !step.field)
            this.$set(step, field, !step[field])
        },

        toggleComplete(step) {
            this.toggle(step, 'complete')
        },

        isActive(step) {
            return this.$page.activeStep && step._id == this.$page.activeStep._id

            // const focus = step._parent.focus
            // if(focus)
            //     return (focus._id == step._id)
        },

        stepFocus(step) {
            this.$page.activeStep = step
            //this.$emit('focus', step)
        },

        stepBlur(step) {
            this.$emit('blur')
        },

        getIconName(step) {
      
            if(step.type == 'task')
                return 'check_circle'
            if(step.type.startsWith('file') )
                return 'cloud_upload'
            return ''

        },

        getIconColour(step) {
            if(step.complete)
                return 'blue'

            return 'rgba(0,0,0,0.1)'
        },

        getStepDOMElement(step) {
            return document.getElementById('step' + step._id)
        },

        randomPercentage() {
            const percent = NumberHelpers.randomIntRange(1, 99)
            if(percent < 30)
                return 0
            if(percent > 70)
                return 100
            return percent
        },

        clicked(event, step) {
            console.log('clicked', step)
            
            if((event.ctrlKey || event.metaKey) ) {
                ObjectArrayHelpers.toggleSelection(step)
                return
            }

            if(event.shiftKey) {     
                const allSteps = this.$page.getAllVisibleSteps()
                
                ObjectArrayHelpers.selectRange(allSteps, step) 
                return   
            }

            this.$page.unselectAll()
            this.selectStep(step)
            
        },

        selectStep(step) {
            this.$set(step, '_selected', true)
        },

        hasLines(step) {
            return step.type == 'task'
        },

        showScheduler() {
            if(this.step.due)
                return true
            if(this.step.showScheduler === false)
                return false
            if(this.step.showScheduler === true)
                return true
            if(this.step.type == 'task')
                return true
            return false
        },

        debouncedDueChanged: Utilities.debounce( (changes, vm) => {
            vm.trackChanges(changes)
        }, 1500),

        trackChanges(changes) {
            console.log('tracking changes', changes)
            this.$page.activities.push(changes)
        }
    },

    created() {
 
    },

    watch: {
        'step.value': {
            handler: function(newVal, oldVal) {
                let changes = {
                    stepId: this.step._id,
                    type: 'Change Data',
                    description: `Changed field '${this.step.title}' from '${oldVal}' to '${newVal}'`
                }
                this.trackChanges(changes)            
            }
        },
        'step.assigned': {
            handler: function(newVal, oldVal) {
                if(newVal == oldVal)
                    return
                let changes = {
                    stepId: this.step._id,
                    type: 'Schedule',
                    description: `Assigned '${this.step.title}' to '${ContactHelpers.fullName(newVal)}'.`
                }
                if(oldVal) 
                    changes.description += ` Previously '${ContactHelpers.fullName(oldVal)}'`
                this.trackChanges(changes)            
            }
        },
        'step.due': {
            handler: function(newVal, oldVal) {
                if(oldVal == newVal)
                    return
                //console.log(oldVal.toString(), newVal.toString(), (oldVal == newVal))
                let changes = {
                    stepId: this.step._id,
                    type: 'Schedule'                
                }
                if(newVal)
                    changes.description = `Scheduled '' for '${DateHelpers.dateToAu(newVal)}'.`
                else
                    changes.description = `Removed due date for ${this.step.title}.`

                if(oldVal) {
                    changes.description += ` Previously '${DateHelpers.dateToAu(oldVal)}'`
                }
                this.debouncedDueChanged(changes, this)            
            }           
        }
    }
}
</script>

<style scoped>
    *:focus {
        outline: none;
    }

    .expander-icon {
        transform: rotate(0deg);
        transition: transform 1s ease;
    }

    .expander-icon.expanded {
        transform: rotate(180deg);
    }

    .new-item-text {
        padding:5px;
        border:solid 2px #ccc;
        border-radius: 5px;
        width:100%; max-width:600px;
    }
    /* .new-item-label {
        padding:5px;
        border:solid 2px transparent;

        width:100%; max-width:600px;
    } */
    /* .heading-label {
        padding:5px 9px;
        border:solid 2px transparent;
        background-color: #ccc;
        color:white;
        font-weight: 600;
        width:100%; max-width:600px;
        border-radius:5px;
    } */


    .flow-step-header.flow-step-line {
        border-bottom: solid 1px #eee;
    }

    .flow-step.no-margin {
        margin-left:0
    }

    .flow-step-icon-shadow {
        border-radius: 999px;
        cursor: pointer;
    }

    @media(hover: hover) {
        .flow-step-header:hover {
            background-color:rgba(0,0,0,0.04);
        }
        .flow-step-icon-shadow:hover {
            background-color:rgba(0,0,0,0.03);
            /* box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3); */
        }
    }

    /* .flow-step.expanded {
        background-color:rgba(0,0,0,0.04);
    } */

    .flow-step-indicator {
        margin:15px 4px 15px 4px;
        width: 4px;
        border-radius: 2px;
        background-color:transparent;
        transition: all .5s ease;
    }
    
    .flow-step-indicator.active {
        margin: 4px;
        background-color: rgba(95, 174, 247, 0.185);
    }

    .flow-step-indicator.selected {
        margin: 4px;
        background-color:rgba(45, 154, 255, 0.7);
    }

    .flow-step-indicator.selected.active {
        margin:4px;
        background-color:rgba(45, 154, 255, 1);
    }

    .flow-step-icon {
        flex-basis:36px;
        border-radius: 999px;
    }

 

    .flow-step-header {
        border: solid 2px transparent;
        display:flex;
        border-radius: 4px;
        /* padding:3px; */
        user-select:none;
        gap:4px;
    }

    .flow-step-header.condensed {
        max-height:34px;
    }

    .flow-step-header.expanded {
        background-color:rgba(0,0,0,0.04);

    }




    .flow-step-content {
        display: flex;
        flex-wrap: wrap;
        flex-grow:1;
        gap:5px;
    }
    .flow-step-input {
        /* flex-basis:300px; */
        flex-grow:1;
    }
    .flow-step-schedule {
        flex-shrink: 1;
        flex-wrap: wrap;
        /* flex-basis: 115px; */
        
        display: flex;
        align-items:center;

    }
    .flow-step-days {
        width:100px;
        text-align:center;
    }
    .flow-step-handle {
        padding-top: 1px;
    }
    .condensed > .flow-step-handle {
        margin-top:-3px;
    }
    .flow-step-assignee {
        font-size: 12px;
        max-width: 70px;
        white-space: nowrap;
        overflow:hidden;
        text-overflow: ellipsis;
    }
    .flow-step-content.selected {
        border-color: #ccc;
    }
    .step-columns {
        display:flex;
    }

    .flow-step-expander {
        padding-left: 20px;
        /* max-height:0;
        overflow-y:scroll; */
        /* transition: max-height .8s ease-in-out, opacity .5s ease-in-out; */
        /* opacity:0; */
        background-color: white;
        /* border-radius:5px; */
        /* margin:0px 0 0px 10px; */
    }
    /* .flow-step-expander.expanded {
        max-height:800px;
        opacity: 1
    } */

    .flow-step-icon .v-icon {
        transition: color 1s ease-in-out;
    }

</style>




// WEBPACK FOOTER //
// Step.vue?5c0a230e